{
  "REPORT": {
    "HEADER": "Konverzace",
    "LOADING_CHART": "Načítání dat mapy...",
    "NO_ENOUGH_DATA": "Pro vytvoření hlášení jsme neobdrželi dostatek dat, zkuste to prosím později.",
    "DOWNLOAD_AGENT_REPORTS": "Stáhnout reporty agentů",
    "DATA_FETCHING_FAILED": "Nepodařilo se načíst data, zkuste to prosím později.",
    "SUMMARY_FETCHING_FAILED": "Nepodařilo se načíst souhrn, zkuste to prosím později.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konverzace",
        "DESC": "( celkem)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Příchozí zprávy",
        "DESC": "( celkem)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchozí zprávy",
        "DESC": "(celkem)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas první odpovědi",
        "DESC": "( Průměrný )",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas první odpovědi je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas vyřešení",
        "DESC": "( Průměrný )",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas vyřešení je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "( celkem )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "( celkem )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Počet předání",
        "DESC": "( celkem )"
      },
      "REPLY_TIME": {
        "NAME": "Doba čekání na odpověď",
        "TOOLTIP_TEXT": "Doba čekání je {metricValue} (na základě {conversationCount} odpovědí)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Dnes",
      "YESTERDAY": "Včera",
      "LAST_7_DAYS": "Posledních 7 dní",
      "LAST_30_DAYS": "Posledních 30 dní",
      "THIS_MONTH": "Tento měsíc",
      "LAST_MONTH": "Minulý měsíc",
      "LAST_3_MONTHS": "Poslední 3 měsíce",
      "LAST_6_MONTHS": "Posledních 6 měsíců",
      "LAST_YEAR": "Poslední rok",
      "CUSTOM_DATE_RANGE": "Vlastní časové rozmezí"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použít",
      "PLACEHOLDER": "Zvolte časové rozmezí"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Seskupit podle",
    "DURATION_FILTER_LABEL": "Doba trvání",
    "GROUPING_OPTIONS": {
      "DAY": "Den",
      "WEEK": "Týden",
      "MONTH": "Měsíc",
      "YEAR": "Rok"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Den"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Den"
      },
      {
        "id": 2,
        "groupBy": "Týden"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Den"
      },
      {
        "id": 2,
        "groupBy": "Týden"
      },
      {
        "id": 3,
        "groupBy": "Měsíc"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Den"
      },
      {
        "id": 2,
        "groupBy": "Týden"
      },
      {
        "id": 3,
        "groupBy": "Měsíc"
      }
    ],
    "BUSINESS_HOURS": "Pracovní doba",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Vymazat filtr",
      "EMPTY_LIST": "Žádné výsledky"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Konverzace: {count}",
      "RESULT_COUNT_MESSAGE": "Zprávy: {count}",
      "EMPTY": "Pro tento sloupec nebyly nalezeny žádné záznamy.",
      "ERROR": "Záznamy se nepodařilo načíst. Zkuste to prosím znovu.",
      "LOAD_MORE": "Načíst další",
      "PREVIOUS_BUCKET": "Předchozí sloupec",
      "NEXT_BUCKET": "Další sloupec",
      "UNKNOWN_CONTACT": "Neznámý kontakt",
      "UNKNOWN_INBOX": "Neznámá schránka",
      "UNASSIGNED_AGENT": "Nepřiřazeno",
      "NO_MESSAGE_CONTENT": "Zpráva nemá obsah",
      "MESSAGE_CREATED_AT": "Zpráva vytvořena {time}",
      "EVENT_OCCURRED_AT": "Událost nastala {time}",
      "INCOMING_MESSAGE": "Příchozí zpráva",
      "OUTGOING_MESSAGE": "Odchozí zpráva",
      "VIEW_ALL": "Zobrazit v konverzacích",
      "VIEW_ALL_LIMIT": "V seznamu konverzací lze otevřít jen sloupce s nejvýše {limit} konverzacemi.",
      "HIDDEN_COUNT": "Nezobrazeno, protože nejste členem jejich schránky: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Zobrazeno {start} až {end} z {total} výsledků",
      "PER_PAGE_TEMPLATE": "{size} / strana"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Přehled agentů",
    "DESCRIPTION": "Snadno sledujte výkonnost agentů pomocí klíčových metrik, jako jsou konverzace, doby odezvy, doby vyřešení a počet vyřešených případů. Kliknutím na jméno agenta zobrazíte další informace..",
    "LOADING_CHART": "Načítání dat mapy...",
    "NO_ENOUGH_DATA": "Pro vytvoření hlášení jsme neobdrželi dostatek dat, zkuste to prosím později.",
    "DOWNLOAD_AGENT_REPORTS": "Stáhnout reporty agentů",
    "FILTER_DROPDOWN_LABEL": "Vybrat agenta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konverzace",
        "DESC": "( celkem )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Příchozí zprávy",
        "DESC": "( celkem )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchozí zprávy",
        "DESC": "( celkem )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "První odpověď za",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas první odpovědi je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas vyřešení",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas vyřešení je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "( celkem )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledních 7 dní"
      },
      {
        "id": 1,
        "name": "Posledních 30 dní"
      },
      {
        "id": 2,
        "name": "Poslední 3 měsíce"
      },
      {
        "id": 3,
        "name": "Posledních 6 měsíců"
      },
      {
        "id": 4,
        "name": "Poslední rok"
      },
      {
        "id": 5,
        "name": "Vlastní časové rozmezí"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použít",
      "PLACEHOLDER": "Zvolte časové rozmezí"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Přehled štítků",
    "DESCRIPTION": "Sledujte výkon štítků pomocí klíčových metrik, včetně konverzací, doby odezvy, doby řešení a vyřešených případů.",
    "LOADING_CHART": "Načítání dat mapy...",
    "NO_ENOUGH_DATA": "Pro vytvoření hlášení jsme neobdrželi dostatek dat, zkuste to prosím později.",
    "DOWNLOAD_LABEL_REPORTS": "Stáhnout reporty štítků",
    "FILTER_DROPDOWN_LABEL": "Vybrat štítek",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konverzace",
        "DESC": "( celkem)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Příchozí zprávy",
        "DESC": "( celkem)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchozí zprávy",
        "DESC": "( celkem)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas první odpovědi",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas první odpovědi je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas vyřešení",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas vyřešení je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "(celkem)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledních 7 dní"
      },
      {
        "id": 1,
        "name": "Posledních 30 dní"
      },
      {
        "id": 2,
        "name": "Poslední 3 měsíce"
      },
      {
        "id": 3,
        "name": "Posledních 6 měsíců"
      },
      {
        "id": 4,
        "name": "Poslední rok"
      },
      {
        "id": 5,
        "name": "Vlastní časové rozmezí"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použít",
      "PLACEHOLDER": "Zvolte časové rozmezí"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Reporty schránek",
    "DESCRIPTION": "Rychle si prohlédněte výkonnost své schránky pomocí klíčových metrik, jako jsou konverzace, doby odezvy, doby vyřešení a počet vyřešených případů – vše na jednom místě. Kliknutím na název schránky zobrazíte další podrobnosti",
    "LOADING_CHART": "Načítání dat mapy...",
    "NO_ENOUGH_DATA": "Pro vytvoření hlášení jsme neobdrželi dostatek dat, zkuste to prosím později.",
    "DOWNLOAD_INBOX_REPORTS": "Stáhnout reporty schránky",
    "FILTER_DROPDOWN_LABEL": "Vybrat schránku",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konverzace",
        "DESC": "( celkem)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Příchozí zprávy",
        "DESC": "( celkem)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchozí zprávy",
        "DESC": "( celkem)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas první odpovědi",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas první odpovědi je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas vyřešení",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas vyřešení je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "( celkem)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledních 7 dní"
      },
      {
        "id": 1,
        "name": "Posledních 30 dní"
      },
      {
        "id": 2,
        "name": "Poslední 3 měsíce"
      },
      {
        "id": 3,
        "name": "Posledních 6 měsíců"
      },
      {
        "id": 4,
        "name": "Poslední rok"
      },
      {
        "id": 5,
        "name": "Vlastní časové rozmezí"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použít",
      "PLACEHOLDER": "Zvolte časové rozmezí"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Přehled týmu",
    "DESCRIPTION": "Získejte přehled o výkonu svého týmu s klíčovými metrikami, včetně konverzací, doby odezvy, doby řešení a vyřešených případů. Pro více detailů klikněte na název týmu.",
    "LOADING_CHART": "Načítání dat mapy...",
    "NO_ENOUGH_DATA": "Pro vytvoření hlášení jsme neobdrželi dostatek dat, zkuste to prosím později.",
    "DOWNLOAD_TEAM_REPORTS": "Stáhnout reporty týmu",
    "FILTER_DROPDOWN_LABEL": "Vybrat tým",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konverzace",
        "DESC": "( celkem)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Příchozí zprávy",
        "DESC": "( celkem)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchozí zprávy",
        "DESC": "( celkem)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas první odpovědi",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas první odpovědi je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas vyřešení",
        "DESC": "(Průměrný)",
        "INFO_TEXT": "Celkový počet konverzací použitých pro výpočet:",
        "TOOLTIP_TEXT": "Čas vyřešení je {metricValue} (na základě {conversationCount} konverzací)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyřešení",
        "DESC": "( celkem)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledních 7 dní"
      },
      {
        "id": 1,
        "name": "Posledních 30 dní"
      },
      {
        "id": 2,
        "name": "Poslední 3 měsíce"
      },
      {
        "id": 3,
        "name": "Posledních 6 měsíců"
      },
      {
        "id": 4,
        "name": "Poslední rok"
      },
      {
        "id": 5,
        "name": "Vlastní časové rozmezí"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použít",
      "PLACEHOLDER": "Zvolte časové rozmezí"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reporty",
    "NO_RECORDS": "Nejsou k dispozici žádné odpovědi z CSAT průzkumu.",
    "DOWNLOAD": "Stáhnout CSAT reporty",
    "DOWNLOAD_FAILED": "Nepodařilo se stáhnout CSAT reporty",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Vybrat agenty"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Přiřazený agent",
        "RATING": "Hodnocení",
        "FEEDBACK_TEXT": "Komentář ke zpětné vazbě"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Celkem odpovědí",
        "TOOLTIP": "Celkový počet shromážděných odpovědí"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Skóre spokojenosti",
        "TOOLTIP": "Celkový počet pozitivních odpovědí / Celkový počet odpovědí * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Míra odpovědí",
        "TOOLTIP": "Celkový počet odpovědí / Celkový počet odeslaných CSAT průzkumů * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Reporty botů",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Počet konverzací",
        "TOOLTIP": "Celkový počet konverzací se zprávami od bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Počet odpovědí",
        "TOOLTIP": "Celkový počet odchozích zpráv"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Počet AI odpovědí",
        "TOOLTIP": "Celkový počet odpovědí odeslaných botem"
      },
      "COPILOT_COUNT": {
        "LABEL": "Počet připravených odpovědí",
        "TOOLTIP": "Celkový počet návrhů odpovědí připravených botem pro agenty"
      },
      "SUCCESS_RATE": {
        "LABEL": "Vyřešeno pomocí AI",
        "TOOLTIP": "Procento konverzací vyřešených AI bez předání agentovi"
      },
      "RESOLVE_TIME": {
        "LABEL": "Doba vyřízení",
        "TOOLTIP": "Medián doby od první zprávy zákazníka do poslední zprávy bota"
      }
    },
    "GROUP_BY": {
      "LABEL": "Seskupit podle",
      "NONE": "Neseskupovat",
      "INBOXES": "Schránky",
      "LABELS": "Štítky"
    },
    "GROUPED": {
      "CHART_TITLE": "Rozložení podle skupin",
      "BACK_TO_ALL": "Zobrazit vše",
      "TABLE": {
        "INBOX": "Schránka",
        "LABEL": "Štítek",
        "CONVERSATIONS": "Konverzace",
        "MESSAGES": "Zprávy",
        "MESSAGES_TOOLTIP": "Celkový počet odchozích zpráv",
        "AI_MESSAGES": "AI odpovědi",
        "AI_MESSAGES_TOOLTIP": "Celkový počet AI odpovědí, následovaný počtem kladných a záporných hodnocení od koncových uživatelů",
        "THUMBS_UP_TOOLTIP": "Počet AI odpovědí hodnocených kladně (palec nahoru) koncovými uživateli",
        "THUMBS_DOWN_TOOLTIP": "Počet AI odpovědí hodnocených záporně (palec dolů) koncovými uživateli",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Kolik % ze všech zpráv v této skupině jsou AI odpovědi",
        "PREPARED": "Připravené odpovědi",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Kolik % zpráv ze všech zpráv spadá do této skupiny",
        "BOT_RESPONSES": "AI odpovědi %",
        "SUGGESTION_USED": "Použité odpovědi",
        "SUGGESTION_USED_TOOLTIP": "Kolik % z připravených odpovědí v této skupině bylo použito",
        "SUGGESTION_NOT_USED": "Nepoužité odpovědi",
        "SUGGESTION_NOT_USED_TOOLTIP": "Kolik % ze všech zpráv v této skupině jsou odpovědi které měly návrh ale nepoužil se"
      },
      "NOTES": {
        "TITLE": "Jak se metriky počítají",
        "CONVERSATIONS": "Počet konverzací, které mají alespoň jednu odchozí zprávu ve vybraném období.",
        "MESSAGES": "Celkový počet odchozích (nesoukromých) zpráv odeslaných ve vybraném období. Zahrnuje zprávy vytvořené AI i agenty.",
        "PERCENTAGE": "Podíl zpráv této skupiny ze všech odchozích zpráv napříč všemi skupinami.",
        "AI_MESSAGES": "Počet odchozích zpráv odeslaných automaticky AI botem (nezahrnuje připravené odpovědi pro agenty). Čísla v závorkách ukazují, kolik z těchto odpovědí hodnotili koncoví uživatelé kladně (palec nahoru) a záporně (palec dolů).",
        "BOT_RESPONSES_PCT": "Podíl AI odpovědí ze všech odchozích zpráv v této skupině.",
        "PREPARED": "Počet návrhů odpovědí (připravených odpovědí) vygenerovaných AI botem pro agenty ve vybraném období. Jedná se o soukromé zprávy viditelné pouze agentům a nejsou započítány jako odchozí zprávy, takže toto číslo nemusí korelovat se sloupcem Zprávy.",
        "SUGGESTION_USED": "Kolik procent z připravených odpovědí v této skupině bylo použito agenty. Nemusí korelovat s počtem připravených odpovědí, protože může zahrnovat i návrhy vygenerované v předchozích obdobích.",
        "SUGGESTION_NOT_USED": "Procento odchozích zpráv v této skupině, kde byl návrh copilota k dispozici, ale agent odpověděl bez jeho použití. Započítává se pouze tehdy, když agent skutečně odeslal odpověď. Nemusí korelovat s počtem připravených odpovědí, protože může zahrnovat i návrhy vygenerované v předchozích obdobích."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Přehled",
    "LIVE": "Živě",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Otevřené konverzace",
      "LOADING_MESSAGE": "Načítání metrik konverzace...",
      "OPEN": "Otevřít",
      "UNATTENDED": "Neobsloužené",
      "UNASSIGNED": "Nepřiřazeno",
      "PENDING": "Čekající"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Provoz konverzací",
      "NO_CONVERSATIONS": "Žádné konverzace",
      "CONVERSATION": "{count} konverzace",
      "CONVERSATIONS": "{count} konverzací",
      "DOWNLOAD_REPORT": "Stáhnout report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Konverzace podle agentů",
      "LOADING_MESSAGE": "Načítání metrik agentů...",
      "NO_AGENTS": "Nejsou žádné konverzace podle agentů",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otevřít",
        "UNATTENDED": "Nezpracované",
        "STATUS": "Stav"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Všechny týmy",
      "HEADER": "Konverzace podle týmů",
      "LOADING_MESSAGE": "Načítání metrik týmu...",
      "NO_TEAMS": "Nejsou dostupná žádná data",
      "TABLE_HEADER": {
        "TEAM": "Tým",
        "OPEN": "Otevřené",
        "UNATTENDED": "Bez odezvy",
        "STATUS": "Stav"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Stav agenta",
      "ONLINE": "Online",
      "BUSY": "Zaneprázdněn",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Neděle",
    "MONDAY": "Pondělí",
    "TUESDAY": "Úterý",
    "WEDNESDAY": "Středa",
    "THURSDAY": "Čtvrtek",
    "FRIDAY": "Pátek",
    "SATURDAY": "Sobota"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA reporty",
    "NO_RECORDS": "Konverzace s použitým SLA nejsou k dispozici.",
    "LOADING": "Načítám SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Stáhnout SLA reporty",
    "DOWNLOAD_FAILED": "Nepodařilo se stáhnout SLA reporty",
    "DROPDOWN": {
      "ADD_FIlTER": "Přidat filtr",
      "CLEAR_ALL": "Vymazat vše",
      "CLEAR_FILTER": "Vymazat filtr",
      "EMPTY_LIST": "Žádné výsledky",
      "NO_FILTER": "Žádné filtry k dispozici",
      "SEARCH": "Hledat filtr",
      "INPUT_PLACEHOLDER": {
        "SLA": "Název SLA",
        "AGENTS": "Jméno agenta",
        "INBOXES": "Název schránky",
        "LABELS": "Název štítku",
        "TEAMS": "Název týmu"
      },
      "SLA": "SLA politika",
      "INBOXES": "Schránka",
      "AGENTS": "Agent",
      "LABELS": "Štítek",
      "TEAMS": "Tým"
    },
    "WITH": "s",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Úspěšnost",
        "TOOLTIP": "Procento vytvořených SLA, které byly úspěšně dokončeny"
      },
      "NO_OF_MISSES": {
        "LABEL": "Počet nedodržení",
        "TOOLTIP": "Celkový počet nedodržení SLA v určitém období"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Počet konverzací",
        "TOOLTIP": "Celkový počet konverzací s SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Politika",
        "CONVERSATION": "Konverzace",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Zobrazit detaily"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Schránka",
    "AGENT": "Agent",
    "TEAM": "Tým",
    "LABEL": "Štítek",
    "TOTAL": "Celkem",
    "SUBTOTAL": "Mezisoučet",
    "NO_TEAM": "Bez týmu",
    "GROUP_BY_TEAMS": "Seskupit podle týmů",
    "AVG_RESOLUTION_TIME": "Prům. doba vyřešení",
    "AVG_FIRST_RESPONSE_TIME": "Prům. doba první odpovědi",
    "AVG_REPLY_TIME": "Prům. doba čekání na odpověď",
    "RESOLUTION_COUNT": "Počet vyřešení",
    "CONVERSATIONS": "Počet konverzací",
    "OUTGOING_CHATS": "Odeslané chat zprávy",
    "OUTGOING_EMAILS": "Odeslané emaily",
    "PHONE_CALLS": "Počet telefonátů",
    "TOTAL_ACTIVITIES": "Celkem aktivit",
    "INBOUND_CALLS": "Příchozí hovory",
    "OUTBOUND_CALLS": "Odchozí hovory",
    "ONLINE_TIME": "Doba online",
    "QUEUE_AVAILABLE_TIME": "Doba dostupnosti ve frontě",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Počet odchozích zpráv odeslaných tímto agentem",
      "OUTGOING_EMAILS": "Počet odchozích zpráv odeslaných tímto agentem",
      "PHONE_CALLS": "Celkový počet telefonních hovorů přiřazených tomuto agentovi (součet příchozích a odchozích hovorů)",
      "TOTAL_ACTIVITIES": "Celkový počet aktivit: příchozí hovory + odchozí hovory + odeslané chat zprávy + odeslané emaily",
      "INBOUND_CALLS": "Počet příchozích telefonních hovorů přiřazených tomuto agentovi",
      "OUTBOUND_CALLS": "Počet odchozích telefonních hovorů přiřazených tomuto agentovi",
      "AVG_FIRST_RESPONSE_TIME": "Průměrná doba od vytvoření konverzace do první odpovědi agenta v konverzacích přiřazených tomuto agentovi",
      "AVG_RESOLUTION_TIME": "Průměrná doba od vytvoření konverzace do jejího vyřešení v konverzacích přiřazených tomuto agentovi",
      "AVG_REPLY_TIME": "Průměrná doba čekání zákazníků mezi jejich zprávou a odpovědí agenta v konverzacích přiřazených tomuto agentovi",
      "ONLINE_TIME": "Celková doba, po kterou byl agent online nebo zaneprázdněn ve vybraném období",
      "QUEUE_AVAILABLE_TIME": "Celková doba, po kterou byl agent dostupný v telefonních frontách ve vybraném období"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonní reporty",
    "DESCRIPTION": "Sledujte metriky telefonních hovorů s podrobnými přehledy příchozích a odchozích hovorů, seskupených podle agenta nebo schránky pro komplexní analýzu.",
    "AGENT_HEADER": "Telefonní reporty - Podle agenta",
    "INBOX_HEADER": "Telefonní reporty - Podle schránky",
    "DOWNLOAD_BUTTON": "Stáhnout telefonní reporty",
    "DOWNLOAD_PHONE_REPORTS": "Stáhnout telefonní reporty",
    "GROUP_BY": {
      "LABEL": "Seskupit podle",
      "AGENT": "Agent",
      "INBOX": "Schránka"
    },
    "TABLE": {
      "AGENT_NAME": "Agent",
      "INBOX_NAME": "Schránka",
      "TOTAL_CALLS": "Celkem",
      "INBOUND_CALLS": "Příchozí",
      "OUTBOUND_CALLS": "Odchozí",
      "FAILED_OUTBOUND_CALLS": "Neúspěšné odchozí",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Úspěšnost odchozí",
      "AVG_AGENT_HANDLED_DURATION": "Prům. doba",
      "TOTAL_AGENT_HANDLED_DURATION": "Celková doba",
      "AVG_RINGING_TIME": "Doba vyzvánění",
      "UNIQUE_CALLERS": "Unikátní volající",
      "UNIQUE_CALLED_CONTACTS": "Unikátní volaní",
      "UNANSWERED_MISSED_CALLS": "Zmeškané nevyřízené",
      "UNANSWERED_MISSED_PERCENTAGE": "Zmeškané nevyřízené %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Zmeškané nevyřízené, dostatečně nevolané",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Zmeškané nevyřízené, dostatečně nevolané %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Celkový počet všech hovorů (včetně nespojených)",
      "INBOUND_CALLS": "Počet spojených hovorů",
      "OUTBOUND_CALLS": "Počet všech odchozích hovorů (včetně nespojených)",
      "FAILED_OUTBOUND_CALLS": "Počet odchozích hovorů, které se nepodařilo spojit",
      "AVG_AGENT_HANDLED_DURATION": "Průměrná doba hovorů vyřízených agenty",
      "TOTAL_AGENT_HANDLED_DURATION": "Celková doba všech hovorů vyřízených agenty",
      "AVG_RINGING_TIME": "Průměrná doba vyzvánění před přijetím hovoru",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Procento odchozích hovorů, které byly úspěšně spojeny",
      "UNIQUE_CALLERS": "Počet unikátních kontaktů, které uskutečnily příchozí hovory",
      "UNIQUE_CALLED_CONTACTS": "Počet unikátních kontaktů, kterým bylo voláno prostřednictvím odchozích hovorů",
      "UNANSWERED_MISSED_CALLS": "Počet zmeškaných hovorů, kde nebylo úspěšně voláno zpět (hovor spojen). Může obsahovat hovory, které lze ještě odbavit v rámci pracovního dne",
      "UNANSWERED_MISSED_PERCENTAGE": "Procento unikátních volajících, jejichž hovory byly zmeškané bez vyřízení (zmeškané nevyřízené hovory / unikátní volající)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Počet zmeškaných hovorů, na které nebylo alespoň 2x voláno zpět. Může obsahovat hovory, které lze ještě odbavit v rámci pracovního dne",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Procento unikátních volajících, na jejichž hovory nebylo alespoň 2x voláno zpět ((zmeškané nevyřízené hovory - dostatečně odbavené) / unikátní volající)"
    },
    "EMPTY_STATE": {
      "TITLE": "Nejsou k dispozici žádná data o telefonních hovorech",
      "MESSAGE": "Ve vybraném časovém rozmezí nejsou žádné telefonní hovory. Zkuste upravit filtry nebo časové rozmezí."
    }
  }
}
